export var IAccountType;
(function (IAccountType) {
    IAccountType["Free"] = "free";
    IAccountType["Paid"] = "pro";
})(IAccountType || (IAccountType = {}));
//# sourceMappingURL=interfaces.js.map